import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, NgForm } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertsService } from 'angular-alert-module';
import { ChangePassword } from '../change_password/change_password.model';
import Swal from 'sweetalert2';


@Component({
  templateUrl: './reset_password.component.html',
  styleUrls: [ './reset_password.component.scss' ]
})

export class ResetPasswordComponent {
  myForm: FormGroup;
  submitted: boolean = false;
  oldpassword;
  newpassword;
  pin;
  token;
  // Form controls
  pswd = new FormGroup({
    email: new FormControl(''),
    newpassword: new FormControl('')
  });

  password: ChangePassword = {
    email: '',
    oldpassword: '',
    newpassword: '',
    // token:''
  };
  hostNameFormWeb: string;
  hostNameFromWeb: string;

  constructor(private auth: AuthenticationService, private router: Router, private route: ActivatedRoute,
              private formBuilder: FormBuilder, private alerts: AlertsService) {}

    ngOnInit() {
      this.route.params.subscribe(params => {
        console.log("params",params['token'])
        // this.token = params['token']
      });

      this.hostNameFromWeb = window.location.hostname
      console.log("Printing the hostname ",this.hostNameFromWeb);
   
      // console.log("decoded",decoded)
      this.myForm = this.formBuilder.group(
        {
          email: ['', [Validators.required, Validators.email]],
          newpassword: ['', [Validators.required, Validators.minLength(5)]]
        }
      );

      // this.route.params.subscribe(params => {
      //   this.pin = params['pin'];
      // });
      //
    }
    get f() { return this.myForm.controls; }

    resetpassword() {
      this.submitted = true;
      if (this.myForm.invalid) {
        console.log("inside invalid",this.myForm.invalid)
        //
        // this.submitted = false
        return;
      }else{
      this.auth.resetpassword(this.password).subscribe(
        (data) => {
          this.submitted = true;

          if (data.code === 200) {
            Swal.fire({
              title: 'Success',
              text: data.success,
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigateByUrl('/');
              }
            })
          } else if (data.code === 400) {
              Swal.fire({
                title: 'Alert',
                text: data.failed,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  // this.router.navigateByUrl('/test_scheduler');
                }
              })

            }
          },
        err => {
          console.error(err);
          Swal.fire({
            title: 'Alert',
            text: 'Email id does not exist',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })
          
        }
      );
      }
    }

    Oncancel() {
        this.router.navigateByUrl('/');
    }
}
